<template>
  <div>
    <list
      row-key="RecordId"
      ref="list"
      unit="广告位"
      :expand-all-row="true"
      :page="page"
      :query-params="params"
      :show-checkbox="$permission.canDel()"
      :show-query="showQuery"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="广告位名称">
          <el-input
            v-model="params.AdTitle"
            placeholder="请输入广告位名称"
            clearable
          />
        </el-form-item>

        <!-- <el-form-item label="状态">
          <el-select v-model="params.State" placeholder="请选择状态" clearable>
            <el-option label="启用" :value="1"></el-option>
            <el-option label="停用" :value="0"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="广告位类型">
          <el-select
            v-model="params.AdType"
            placeholder="请选择广告位类型"
            clearable
            >
            <el-option label="资源广场" :value="1"></el-option>
            <el-option label="项目招商" :value="2"></el-option>
            <el-option label="用户风采" :value="3"></el-option>
            <!-- <el-option label="企业用户" :value="4"></el-option> -->
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column
          prop="OrderId"
          label="序号"
          align="center"
          width="60"
        />
        <el-table-column prop="AdType" label="广告位类型">
          <template slot-scope="{ row }">
            <span v-if="row.AdType == 1">资源广场</span>
            <span v-if="row.AdType == 2">项目招商</span>
            <span v-if="row.AdType == 3">用户风采</span>
            <!-- <span v-if="row.AdType == 4">企业用户</span> -->
          </template>
        </el-table-column>
        <el-table-column prop="AdTitle" label="广告位名称" />
        <el-table-column prop="StateStr" label="关联状态" />

        <!-- <el-table-column prop="State" width="80px" label="状态" align="center">
          <template slot-scope="{ row }">
            <el-tag type="success" v-if="row.State == 1">启用</el-tag>
            <el-tag type="danger" v-else>停用</el-tag>
          </template>
        </el-table-column> -->

        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
  <script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/store/advertising").default,
      params: {
        AdTitle: "",
        AdType: null,
      },
    };
  },
  methods: {
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>